import { put, select } from "redux-saga/effects";

import type { TopicPublicationApplySearchCriteria } from "domains/publication/actionTypes";
import { getPublicationSearchCriteria } from "domains/publication/selectors";
import { getTmSelectedId, getTmSelectedOuterNodeId } from "domains/transformationMap/selectors";
import { fetchPublicationForTopic } from "entities/publication/actions";

export function* applyPublicationSearchCriteriaSaga(action: TopicPublicationApplySearchCriteria) {
  const searchCriteria: ReturnType<typeof getPublicationSearchCriteria> = yield select(getPublicationSearchCriteria);
  const tmSelectedId: ReturnType<typeof getTmSelectedId> = yield select(getTmSelectedId);
  const secondaryTopicId: ReturnType<typeof getTmSelectedOuterNodeId> = yield select(getTmSelectedOuterNodeId);

  const id = action.payload?.topicId ?? tmSelectedId;
  if (id !== undefined) yield put(fetchPublicationForTopic({ ...searchCriteria, id, secondaryTopicId }, action.meta));
}
